import React from 'react'
import HomeSlider from './../../HomeSlider/HomeSlider';
import Productsection from '../Productsection/Productsection';
import Section1 from './../Section1/Section1';
import LiveProducts from '../LiveProducts/LiveProducts';
import Section2 from '../Section2/Section2';
import LiveotherProducts from '../LiveotherProducts/LiveotherProducts';

function Home() {
    return (
      <div>
        <HomeSlider />
        <Productsection />
        <Section1 />
        <LiveProducts />
        <Section2 />
        <LiveotherProducts/>
      </div>
    );
}

export default Home
